//Only letters and all must be mayus and optional separated by a - and then a number
export const FORMAT_ID = /^[A-Z]+(-[0-9,.A-Z]+)?$/
